import { render } from "./EncyclopediaEntryPage.vue?vue&type=template&id=677b04a0&scoped=true"
import script from "./EncyclopediaEntryPage.vue?vue&type=script&lang=js"
export * from "./EncyclopediaEntryPage.vue?vue&type=script&lang=js"

import "./EncyclopediaEntryPage.vue?vue&type=style&index=0&id=677b04a0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677b04a0"]])

export default __exports__